import PropTypes from 'prop-types';
import { useRef } from 'react';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(useGSAP, ScrollTrigger);

function AnimationStripedItemsFromList({ className, itemsToStrip, showNewItems, itemsToShow, itemsToShowLabel }) {
    const containerClasses = (className) ? `animation--striped animation--striped-gsap ${className}` : "animation--striped animation--striped-gsap";

    // Mise en place de la référence concernant la liste des éléments à rayer
    const listRef = useRef(null);

    useGSAP(() => {
        // On sécurise le hook GSAP
        const list = listRef.current;
        if(!list) return;

        // On créé une variable stockant l'ensemble des éléments <s>
        const listItems = list.querySelectorAll('.striped-item');

        // Initialisation des variables CSS à 0
        listItems.forEach(item => {
            gsap.set(item, { "--anim-rayure-width": "0%" });
        });

        // Initialisation de la timeline
        const tl = gsap.timeline({ paused: true });

        // On ajoute l'animation de la rayure
        tl.to(listItems, {
            "--anim-rayure-width": "100%",
            duration: 0.6,
            ease: "power2.out",
            stagger: 0.5
        });

        // On définit le ScrollTrigger
        ScrollTrigger.create({
            trigger: list,
            animation: tl,
            start: 'bottom center',
            end: 'bottom+=200 center',
            scrub: true,
            toggleActions: "play reverse play reverse",
        });

    }, { scope: listRef, dependencies: [itemsToStrip] });

    return (
        <ul ref={listRef} className={containerClasses}>
            {itemsToStrip.map((stripedItem, index) => (
                <li key={'item-' + index}>
                    <span className="sr-only">
                        {showNewItems ? `${stripedItem} ${itemsToShowLabel || 'est devenu'} ${itemsToShow[index]}` : 'mots raturés ' + stripedItem}
                    </span>
                    <s aria-hidden="true" className="striped-item">{stripedItem}</s>
                    {showNewItems &&
                        <span aria-hidden="true">&nbsp;{itemsToShow[index]}</span>
                    }
                </li>
            ))}
        </ul>
    )
}

AnimationStripedItemsFromList.propTypes = {
    className: PropTypes.string,
    itemsToStrip: PropTypes.object.isRequired,
    showNewItems: PropTypes.bool.isRequired,
    itemsToShow: PropTypes.element,
    itemsToShowLabel: PropTypes.string
}

export default AnimationStripedItemsFromList;
